import React, {
  useState,
} from 'react';

import {
  Flex,
} from 'web-styled';

import Link from '../Link';
import * as S from '../styled';

type Item = {
  id?: number;
  link: string;
  icon?: string;
  name: string;
  level?: number;
};

type Props = {
  isFolder: boolean;
  badge: string;
  children: Item[];
} & Item;

const SidebarItem = React.forwardRef<HTMLDivElement, Props>(({
  id,
  link,
  icon,
  name,
  badge,
  isFolder,
  children,
  ...rest
}: Props, ref) => {
  const level = rest.level || 0;
  const [isOpen, setOpen] = useState(false);

  const basePath = isFolder ? `${link}_folder` : link;
  const to = `/${basePath}${id ? `/${id}` : ''}`;

  return (
    <Flex
      column
      width="100%"
      shrink="0"
      ref={ref}
      {...rest}
    >
      <Link
        to={to}
        icon={icon}
        name={name}
        link={link}
        level={level || 0}
        badge={badge}
        isOpen={isOpen}
        isFolder={isFolder}
        setOpen={setOpen}
        hasChild={children?.length > 0}
      />

      {isOpen && (
        <S.Sub
          isOpen={isOpen}
          showLine={isFolder && level > 0}
          leftLine={`${level > 1 ? (level * 35) - 21 : 21}px`}
        >
          {children.map(item => (
            <SidebarItem
              key={item.id || item.link}
              link={item.link || link}
              level={level ? level + 1 : 1}
              icon={icon}
              {...item}
            />
          ))}
        </S.Sub>
      )}
    </Flex>
  );
});

SidebarItem.defaultProps = {
  id: null,
  icon: null,
  level: 0,
};

export default SidebarItem;
